module.exports = __webpack_public_path__ + "media/images/default/pages/public_science_2/2-6-de40f4c62fcb91de00821c13214550c7.png";